import { render, staticRenderFns } from "./maintain-orders-statistics.vue?vue&type=template&id=1963dbfd&scoped=true"
import script from "./maintain-orders-statistics.vue?vue&type=script&lang=js"
export * from "./maintain-orders-statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1963dbfd",
  null
  
)

export default component.exports